// Pure helpers for SmartTaskCard. Kept separate from the component so
// they can be unit-tested without a DOM renderer (RTL is not installed
// in this project — see __tests__/components/ArtworkEditModal.test.js).

const SEVERITY_DOT_CLASS = {
  critical: 'admin-smart-task-card__dot--critical',
  warning: 'admin-smart-task-card__dot--warning',
  attention: 'admin-smart-task-card__dot--attention',
  info: 'admin-smart-task-card__dot--info',
  clear: 'admin-smart-task-card__dot--clear',
}

export function isClearSeverity(severity) {
  return severity === 'clear'
}

export function severityDotClass(severity) {
  return SEVERITY_DOT_CLASS[severity] || 'admin-smart-task-card__dot'
}
